const { ShopifyAnalytics: { meta: { page: { pageType: shopifyPageType } = {} } = {} } = {} } = window;

function isCollectionWithPath(pathPart) {
  if (shopifyPageType === 'collection' && window.location.pathname.includes(pathPart)) {
    return true;
  }
  return false;
}

const searchPageUrl = '/pages/search';

const isSamplesPage = isCollectionWithPath('samples');

const paginationOptions =
  window.innerWidth > 540
    ? {
        centralRange: 4,
        edgeRange: 1,
      }
    : {
        centralRange: 2,
        edgeRange: 1,
      };

function updateCallback() {
  if (document.querySelector('#vertical-widget-720 iframe') === null) {
    window.initCollectionSidebarReviews?.();
  }
}

function responseHandler(response) {
  window.Convermax.CollectionVideo = response.Extra.CollectionVideo;
  return response;
}

window.Convermax.getYouTubeId = (url) => {
  // eslint-disable-next-line no-useless-escape
  const regExp = /.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#\&\?]*).*/;
  const match = url.match(regExp);
  return match?.[1] || false;
};

export default {
  platform: 'shopify',
  searchPageUrl,
  responseHandler,
  stickyHeaderSelector: '.site-header.site-header-nav--open',
  SearchRequestDefaults: {
    pageSize: 96,
  },
  ColorEngineFeature: true,
  product: {
    noImageSrc:
      'https://cdn.shopify.com/s/files/1/0648/1028/7331/files/Product_Placeholder_Image.jpg?width=500',
  },
  pagination: paginationOptions,
  facets: {
    simpleFacet: {
      fields: [
        'fabric-menu-collections',
        'wallpaper-menu-collections',
        'fabric-menu-designer-collections',
        'wallpaper-menu-designer-collections',
      ],
      name: 'collectionMenuFacet',
    },
  },
  Widgets: [
    {
      name: 'SearchPage',
      location: {
        replace: '#cm_results, #cm_SearchPage',
        class: 'productgrid--outer layout--has-sidebar productgrid-gridview',
      },
      template: 'SearchPage',
    },
    {
      name: 'CategoryPage',
      type: 'SearchPage',
      location: {
        insertBefore: 'body.template-collection .productgrid--wrapper',
        class: 'productgrid--wrapper cm_main-content',
      },
      template: 'MainContent',
    },
    {
      name: 'FacetPanelCategory',
      type: 'FacetPanel',
      location: {
        replace: '.productgrid--sidebar',
        class: 'cm_FacetPanel_container',
      },
      template: 'FacetPanelContainer',
    },
    {
      name: 'FacetCategoryTiles',
      type: 'FacetTiles',
      location: {
        replace:
          '.template-list-collections .collection-list__content.collection--image-crop-original DISABLED',
      },
      template: 'facetTiles/hierarchicalContainer',
      isVehicleWidgetDisabled: true,
    },
    {
      name: 'FacetBrandTiles',
      type: 'FacetTiles',
      location: {
        selector: '#cm_brands-page DISABLED',
        class: 'collection-list__container',
      },
      template: 'facetTiles/hierarchicalContainer',
      isVehicleWidgetDisabled: true,
    },
    {
      name: 'SearchHeader',
      sortEntries: {
        'relevance': 'Best Match',
        'title': 'Name, A-Z',
        'title:desc': 'Name, Z-A',
        'collection_sort': 'Featured',
        'price': 'Price, low to high',
        'price:desc': 'Price, high to low',
        'published_at': 'Date, old to new',
        'published_at:desc': 'Date, new to old',
      },
    },
    {
      name: 'SearchResult',
      updateCallback,
    },
    {
      name: 'FacetPanel',
    },
    {
      name: 'FilterSearchBox',
      visibleIf: () => isSamplesPage,
    },
    {
      name: 'SearchBox',
      location: {
        replace: 'body.cm_desktop .live-search[data-live-search]',
        class: 'live-search',
      },
      template: 'SearchBox',
    },
    {
      name: 'SearchHeaderCategoryMobile',
      type: 'SearchHeader',
      template: 'FacetButton',
      location: '.productgrid--utils.utils-filter',
    },
    {
      name: 'SearchBoxDialogButton',
      location: {
        insertAfter: 'body.cm_mobile .site-header-menu-toggle',
        class: 'cm_search-box-root__dialog-container cm_desktop-hide site-header-menu-toggle',
      },
      template: 'searchBox/dialogButtonMobile',
    },
    {
      name: 'SearchBoxDialog',
      template: 'SearchBoxDialog',
    },
    {
      name: 'FacetDialog',
      template: 'FacetDialog',
    },
    {
      name: 'SimpleColorPaletteDialog',
      field: '_Color',
      template: 'colorSearch/simplePaletteDialog',
    },
    {
      name: 'ColorExtractorDialog',
      field: '_Color',
      template: 'colorSearch/colorExtractorDialog',
    },
  ],
};
